export const JAM_REGISTRATION_STATUS_LABELS: Record<string, string> = {
  pending: "ລໍຖ້າຕິດຕໍ່",
  contacted: "ຕິດຕໍ່ແລ້ວ",
  confirmed: "ຢືນຢັນແລ້ວ",
  rejected: "ປະຕິເສດ",
  duplicate: "ຊ້ຳ",
  converted: "ແປງເປັນນັກຮຽນແລ້ວ",
};

export const JAM_REGISTRATION_STATUS_VARIANTS: Record<
  string,
  "default" | "secondary" | "destructive" | "outline"
> = {
  pending: "outline",
  contacted: "secondary",
  confirmed: "default",
  rejected: "destructive",
  duplicate: "outline",
  converted: "secondary",
};

export const JAM_EVENT_STATUS_LABELS: Record<string, string> = {
  draft: "ຮ່າງ (ຍັງບໍ່ເປີດ)",
  open: "ເປີດຮັບສະໝັກ",
  closed: "ປິດຮັບສະໝັກ",
};

export const JAM_EVENT_STATUS_VARIANTS: Record<
  string,
  "default" | "secondary" | "destructive" | "outline"
> = {
  draft: "outline",
  open: "default",
  closed: "secondary",
};

export const JAM_EVENT_STATUS_HINTS: Record<string, string> = {
  draft: "ຟອມສາທານະຈະບໍ່ຮັບສະໝັກ — ໃຊ້ທົດສອບກ່ອນເປີດ",
  open: "ເວັບ Summer Camp ສາມາດສົ່ງໃບສະໝັກ Jam ໄດ້",
  closed: "ເວັບຈະສະແດງຫນ້າປິດຮັບສະໝັກ",
};

export const JAM_FORMAT_LABELS: Record<string, string> = {
  solo: "1vs1 / Solo",
  duo: "2vs2 / Duo",
};

export const JAM_KIND_LABELS: Record<string, string> = {
  qualifier: "Qualifier",
  battle: "Battle",
};
